import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.NEWSFLASH;

export const IS_INTERMEDIATE_SAVING_DISABLED = false;
// increment this value if you need to change the shape of a user's save data
// in a way that will invalidate previous data.
// the saveDataReducer will automatically ignore any save data with a version lower than this value.
export const CURRENT_SAVE_DATA_VERSION = 3;

export const LEVEL_COUNT = 9;
export const ONBOARDING_LEVEL_ID = 0;

export const SIMPLE_FEEDBACK_THRESHOLD = 1; // the number of incorrect answers you must submit before getting some basic scaffolding
export const EXPLICIT_FEEDBACK_THRESHOLD = 3; // the number of incorrect answers you must submit before the answer is just given to you

export const ANSWER_TYPE = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  NO_ANSWER: 'no_answer',
  PENDING: 'pending',
};

export const LEVEL_MASTERY_THRESHOLD = 2; // the number of mistakes you are allowed to make in a full level without failing.
export const ITEM_MASTERY_THRESHOLD = 2; // number of times you can incorrectly answer a question before failing it.

export const NO_TAG = {
  color: ['', ''],
  text: 'none',
};

export const UNTAG_OPTION = {
  color: 'black',
  text: 'untag',
};

export const STORY_ELEMENT_TAGS = {
  character: {
    color: ['#ffd2ff', '#db2780'],
    text: 'character',
    nameInCurriculum: 'character',
    description: 'a character is who the story is about. What words in the story tell you the characters?',
    iconName: 'Character',
    isButtonOutlined: false,
  },
  where: {
    color: ['#c8f08f', '#4b8400'],
    text: 'setting : where',
    nameInCurriculum: 'where',
    description: 'a setting is where and when a story takes place. What words in the story tell you the setting?',
    iconName: 'Compass',
    isButtonOutlined: false,
  },
  when: {
    color: ['#9bfcd4', '#008462'],
    text: 'setting : when',
    nameInCurriculum: 'when',
    description: 'a setting is where and when a story takes place. What words in the story tell you the setting?',
    iconName: 'Clock',
    isButtonOutlined: false,
  },
  problem: {
    color: ['#eed2ff', '#9651d4'],
    text: 'problem',
    nameInCurriculum: 'problem',
    description: 'a problem in the story is a reason the character can’t achieve the goal. What words in the story tell you about a problem?',
    iconName: 'BrokenPuzzle',
    isButtonOutlined: false,
  },
  resolution: {
    color: ['#ffdda3', '#d74108'],
    text: 'resolution',
    nameInCurriculum: 'resolution',
    description: 'a resolution is the way the problem is finally fixed so the character can achieve their goal. What words in the story tell you about a resolution?',
    iconName: 'Puzzle',
    isButtonOutlined: false,
  },
  untag: {
    color: ['white', '#979797'],
    text: 'untag',
    nameInCurriculum: 'untag', // just for consistency's sake.
    description: 'N/A',
    iconName: 'X',
    isButtonOutlined: true,
  },
};
/* eslint-enable */

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
  INTRO: 'INTRO',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  END_OF_LEVEL: 'END_OF_LEVEL',
};

export const REDUX_ACTIONS = {
  CLEAR_SAVED_DATA_BY_KEY: 'CLEAR_SAVED_DATA_BY_KEY',
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  SELECT_FEEDBACK: 'SELECT_FEEDBACK',
  SET_ANSWER_AS_PENDING: 'SET_ANSWER_AS_PENDING',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  COMPLETE_INTRO_SCENE: 'COMPLETE_INTRO_SCENE',
  SET_LEVEL_ID: 'SET_LEVEL_ID',
  COMPLETE_CHECKPOINT_ITEM: 'COMPLETE_CHECKPOINT_ITEM',
  QUICK_ROUND: 'QUICK_ROUND',

  SELECT_TAGGING_MODE: 'SELECT_TAGGING_MODE',
  SELECT_WORD_GROUP: 'SELECT_WORD_GROUP',
  REGISTER_TAGGABLE_WORD_LAYOUT: 'REGISTER_TAGGABLE_WORD_LAYOUT',

  TOGGLE_DIARY_PANEL: 'TOGGLE_DIARY_PANEL',

  START_EXPLICIT_FEEDBACK: 'START_EXPLICIT_FEEDBACK',
  RESET_FEEDBACK: 'RESET_FEEDBACK',

  SHOW_HEADLINES_MENU: 'SHOW_HEADLINES_MENU',
  SELECT_HEADLINE_TEXT: 'SELECT_HEADLINE_TEXT',
  DISABLE_TAGGING_OPTION: 'DISABLE_TAGGING_OPTION',

  SHOW_FINAL_PAYOFF_PHONE: 'SHOW_FINAL_PAYOFF_PHONE',

  END_OF_GUIDED_SEQUENCE: 'END_OF_GUIDED_SEQUENCE',

  SET_CURRENT_GUIDED_SEQUENCE_NAME: 'SET_CURRENT_GUIDED_SEQUENCE_NAME',
  HIGHLIGHT_TAGGING_MODE: 'HIGHLIGHT_TAGGING_MODE',
  SET_HIGHLIGHT_QUESTION_MARKS: 'SET_HIGHLIGHT_QUESTION_MARKS',
  UNDERLINE_CORRECT_ANSWER: 'UNDERLINE_CORRECT_ANSWER',

  SET_TARGET_INTERACTION_WITH_ID: 'SET_TARGET_INTERACTION_WITH_ID',
  ADD_ID_TO_INTERACTION_BLACKLIST: 'ADD_ID_TO_INTERACTION_BLACKLIST',
  SET_UP_AUTO_COMPLETE: 'SET_UP_AUTO_COMPLETE',
  START_OBOARDING: 'START_OBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',

  PRESS_QUESTION_MARK: 'PRESS_QUESTION_MARK',
  SET_LAST_LEVEL_CLICKED: 'SET_LAST_LEVEL_CLICKED',
  SET_WORD_COUNT_IN_ITEM: 'SET_WORD_COUNT_IN_ITEM',
  TRY_UNLOCK_NEXT_LEVEL: 'TRY_UNLOCK_NEXT_LEVEL',

  SELECT_ACTIVITY: 'SELECT_ACTIVITY',
  STOP_VO: 'STOP_VO',

  UPDATE_RECORDS: 'UPDATE_RECORDS',
};
